module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"answer":"Answer to {name}"},"fr":{"answer":"En réponse à {name}"}}')
  delete Component.options._Ctor
}
